import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card-global" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = { class: "filter-container" }
const _hoisted_5 = { class: "grid grid-cols-12 gap-6" }
const _hoisted_6 = { class: "col-span-4 md:col-span-4 sm:col-span-4" }
const _hoisted_7 = {
  for: "company-id",
  class: "block text-sm font-medium text-gray-700"
}
const _hoisted_8 = { class: "col-span-4 md:col-span-4 sm:col-span-4" }
const _hoisted_9 = { class: "block text-sm" }
const _hoisted_10 = { class: "col-span-4 md:col-span-4 sm:col-span-4" }
const _hoisted_11 = {
  for: "user-job",
  class: "block text-sm"
}
const _hoisted_12 = { value: null }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "col-span-4 md:col-span-4 sm:col-span-4" }
const _hoisted_15 = {
  for: "user-role",
  class: "block text-sm"
}
const _hoisted_16 = { value: null }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "col-span-4 md:col-span-4 sm:col-span-4" }
const _hoisted_19 = { class: "block text-sm" }
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "col-span-4 md:col-span-4 sm:col-span-4" }
const _hoisted_22 = { class: "block text-sm" }
const _hoisted_23 = { value: null }
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "mt-10 flex justify-between" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "relative" }
const _hoisted_28 = { class: "flex flex-row-reverse" }
const _hoisted_29 = { style: {"height":"440px","overflow-y":"scroll"} }

import { onMounted, computed, reactive, ref } from "vue";
import { PencilIcon, TrashIcon } from "@heroicons/vue/solid";
import { useToast } from "vue-toastification";
import DeactivateEntityModal from "@/components/common/DeactivateEntityModal.vue";
import { EyeIcon } from "@heroicons/vue/solid";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { UserActions } from "@/store/modules/user/actions";
import { UserGetters } from "@/store/modules/user/getters";
import VueTableLite from "vue3-table-lite/ts";
import StatusLabel from "@/components/common/StatusLabel.vue";
import { ActionMenu } from "@/components/common";
import {
  DotsHorizontalIcon,
  SearchIcon,
  PlusIcon,
} from "@heroicons/vue/outline";
import TablePagination from "@/components/common/pagination/TablePagination.vue";
import { getCommonStatusOptions } from "@/utils/labels";
import { CompanyActions } from "@/store/modules/company/actions";
import { CompanyGetters } from "@/store/modules/company/getters";
import { RoleActions } from "@/store/modules/role/actions";
import { JobActions } from "@/store/modules/job/actions";
import { JobGetters } from "@/store/modules/job/getters";
import { RoleGetters } from "@/store/modules/role/getters";
import Modal from "@/components/common/Modal.vue";
import { Company } from "@/types";
import { t } from "@/i18n";
import TreeListMulti from "@/components/common/TreeListMulti.vue";
import { AuthGetters } from "@/store/modules/auth";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const route = useRoute();
const store = useStore();
const toast = useToast();

const deactivateModalShow = ref(false);
const deactivateTargetId = ref<string | null>(null);

const isShowCompanyModal = ref(false);

onMounted(async () => {
  await store.dispatch(UserActions.FETCH_DATA_PROVIDER, { page: 0 });

  await store.dispatch(CompanyActions.FETCH_ALL);
  companies.value = store.getters[CompanyGetters.GET_ALL];
  await store.dispatch(JobActions.FETCH_ALL);
  jobs.value = store.getters[JobGetters.GET_ALL];
  await store.dispatch(RoleActions.FETCH_ALL);
  roles.value = store.getters[RoleGetters.GET_ALL];
});

const dataProvider = computed(() => {
  return store.getters[UserGetters.GET_DATA_PROVIDER];
});
const users = computed(() => {
  return dataProvider.value.items;
});
const currentUser = computed(
  () => store.getters[AuthGetters.GET_USER_IDENTITY]
);
const permissions = computed<string[]>(() =>
  Array.isArray(currentUser.value?.permissions)
    ? currentUser.value.permissions
    : []
);
const canCreateUser = computed(() => permissions.value.includes("USER_CREATE"));
const canEditUser = computed(() => permissions.value.includes("USER_EDIT"));
const canDeactivateUser = computed(() =>
  permissions.value.includes("USER_DEACTIVATE")
);
const pager = computed(() => {
  return dataProvider.value.pager;
});

const dropDownActions = computed(() => {
  const actions = [
    {
      text: t("common.details"),
      icon: EyeIcon,
      iconColor: "text-slate-500",
      action: async (id: string) => {
        await router.push({ name: "UserDetails", params: { id: id } });
      },
    },
  ];

  if (canEditUser.value) {
    actions.push({
      text: t("common.edit"),
      icon: PencilIcon,
      iconColor: "text-green-500",
      action: (id: string) => {
        router.push({ name: "UserEdit", params: { id: id } });
      },
    });
  }

  if (canDeactivateUser.value) {
    actions.push({
      text: t("userDetails.delete"),
      icon: TrashIcon,
      iconColor: "text-red-500",
      action: (id: string) => {
        deactivateTargetId.value = id;
        deactivateModalShow.value = true;
      },
    });
  }

  return actions;
});

const confirmDeactivate = async (coordinatorId?: string) => {
  if (deactivateTargetId.value == null) {
    return;
  }
  try {
    await store.dispatch(UserActions.DELETE, {
      id: deactivateTargetId.value,
      coordinatorId,
    });
    toast.success(t("approval.submitted"));
    deactivateModalShow.value = false;
    await store.dispatch(UserActions.FETCH_DATA_PROVIDER, {
      page: pager.value.currentPage,
      ...filter.value,
    });
  } catch {
    toast.error(t("deactivate.error"));
  }
};

const getPage = async (page: number) => {
  await store.dispatch(UserActions.FETCH_DATA_PROVIDER, { page: page });
};

// Filter
const companies = ref([]);
const roles = ref([]);
const statusOptions = computed(() => getCommonStatusOptions());
const jobs = ref([]);
const filter = ref({
  fullName: "",
  iin: "",
  status: null as string | null,
  company: null,
  job: null,
  roleId: null,
});
const companyName = computed(() => {
  const company: Company | undefined = companies.value.find(
    (item: Company) => item.id === filter.value.company
  );

  return company ? company.name : t("common.notSelected");
});
const updateFilter = async () => {
  try {
    await store.dispatch(UserActions.FETCH_DATA_PROVIDER, filter.value);
  } catch (e) {
    console.log(e);
  }
};

const table = reactive({
  isLoading: false,
  columns: [
    {
      label: t("common.name"),
      field: "name",
      sortable: false,
    },
    {
      label: t("common.surname"),
      field: "surname",
      sortable: false,
    },
    {
      label: t("common.iin"),
      field: "iin",
      sortable: false,
    },
    {
      label: "Email",
      field: "email",
      sortable: false,
    },
    {
      label: t("common.status"),
      field: "status",
      sortable: false,
    },
    {
      label: "",
      field: "action",
      sortable: false,
    },
  ],
  rows: users,
  totalRecordCount: 0,
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)("userList.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(t)("common.fullName")), 1),
          _withDirectives(_createElementVNode("input", {
            type: "search",
            class: "input-form w-full flex-none w-2/5",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filter.value.fullName) = $event))
          }, null, 512), [
            [_vModelText, filter.value.fullName]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(t)("common.iin")), 1),
          _withDirectives(_createElementVNode("input", {
            type: "search",
            class: "input-form w-full flex-none w-2/5",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filter.value.iin) = $event))
          }, null, 512), [
            [_vModelText, filter.value.iin]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(t)("common.job")), 1),
          _withDirectives(_createElementVNode("select", {
            id: "user-job",
            name: "user-status",
            class: "input-form block w-full flex-1",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filter.value.job) = $event))
          }, [
            _createElementVNode("option", _hoisted_12, _toDisplayString(_unref(t)("common.allJobs")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobs.value, (job, index) => {
              return (_openBlock(), _createElementBlock("option", {
                value: job.id,
                key: index
              }, _toDisplayString(job.name), 9, _hoisted_13))
            }), 128))
          ], 512), [
            [_vModelSelect, filter.value.job]
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("label", _hoisted_15, _toDisplayString(_unref(t)("common.role")), 1),
          _withDirectives(_createElementVNode("select", {
            id: "user-role",
            name: "user-status",
            class: "input-form block w-full flex-1",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filter.value.roleId) = $event))
          }, [
            _createElementVNode("option", _hoisted_16, _toDisplayString(_unref(t)("common.allRoles")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roles.value, (role, index) => {
              return (_openBlock(), _createElementBlock("option", {
                value: role.id,
                key: index
              }, _toDisplayString(role.name), 9, _hoisted_17))
            }), 128))
          ], 512), [
            [_vModelSelect, filter.value.roleId]
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("label", _hoisted_19, _toDisplayString(_unref(t)("common.company")), 1),
          _createElementVNode("input", {
            class: "input-form w-full cursor-pointer",
            type: "text",
            value: _unref(companyName),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (isShowCompanyModal.value = true)),
            readonly: ""
          }, null, 8, _hoisted_20)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("label", _hoisted_22, _toDisplayString(_unref(t)("common.status")), 1),
          _withDirectives(_createElementVNode("select", {
            id: "user-status",
            name: "user-status",
            class: "input-form block w-full flex-1",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filter.value.status) = $event))
          }, [
            _createElementVNode("option", _hoisted_23, _toDisplayString(_unref(t)("common.allStatuses")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(statusOptions), (status, index) => {
              return (_openBlock(), _createElementBlock("option", {
                value: index,
                key: index
              }, _toDisplayString(status), 9, _hoisted_24))
            }), 128))
          ], 512), [
            [_vModelSelect, filter.value.status]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createVNode(_component_Button, {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (updateFilter())),
          class: "btn-search"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(SearchIcon), { class: "button-icon mr-2" }),
            _createTextVNode(" " + _toDisplayString(_unref(t)("common.search")), 1)
          ]),
          _: 1
        }),
        (_unref(canCreateUser))
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createVNode(_component_router_link, { to: { name: 'UserCreate' } }, {
                default: _withCtx(() => [
                  _createVNode(_component_Button, { class: "flex px-10" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(PlusIcon), { class: "button-icon mr-2" }),
                      _createTextVNode(" " + _toDisplayString(_unref(t)("common.create")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_unref(VueTableLite), {
      "data-pagination-scroll-anchor": "",
      "is-slot-mode": true,
      "is-loading": _unref(table).isLoading,
      columns: _unref(table).columns,
      rows: _unref(table).rows,
      total: _unref(table).totalRecordCount,
      sortable: false,
      "is-hide-paging": true,
      messages: { noDataAvailable: _unref(t)('common.noData') }
    }, {
      status: _withCtx((data) => [
        _createVNode(StatusLabel, {
          label: data.value.status
        }, null, 8, ["label"])
      ]),
      action: _withCtx((data) => [
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_unref(ActionMenu), {
            actions: _unref(dropDownActions),
            item: data.value
          }, null, 8, ["actions", "item"])
        ])
      ]),
      _: 1
    }, 8, ["is-loading", "columns", "rows", "total", "messages"]),
    _createElementVNode("div", _hoisted_28, [
      _createVNode(TablePagination, {
        current: _unref(pager).currentPage,
        "onUpdate:current": _cache[7] || (_cache[7] = ($event: any) => ((_unref(pager).currentPage) = $event)),
        "total-pages": _unref(pager).totalPages,
        "onUpdate:total-pages": _cache[8] || (_cache[8] = ($event: any) => ((_unref(pager).totalPages) = $event)),
        "start-page": _unref(pager).startPage,
        "end-page": _unref(pager).endPage,
        onPageChanged: getPage
      }, null, 8, ["current", "total-pages", "start-page", "end-page"])
    ]),
    _createVNode(Modal, {
      show: isShowCompanyModal.value,
      onClose: _cache[12] || (_cache[12] = ($event: any) => (isShowCompanyModal.value = false)),
      title: _unref(t)('common.companies')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_29, [
          _createVNode(TreeListMulti, {
            items: companies.value,
            "active-id": filter.value.company,
            "parent-column": "parentId",
            onSelect: _cache[9] || (_cache[9] = ($event: any) => (filter.value.company = $event.id))
          }, null, 8, ["items", "active-id"])
        ]),
        _createVNode(_component_Button, {
          onClick: _cache[10] || (_cache[10] = ($event: any) => (isShowCompanyModal.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("common.confirm")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          class: "ml-2",
          onClick: _cache[11] || (_cache[11] = ($event: any) => {
          filter.value.company = null;
          isShowCompanyModal.value = false;
        })
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("common.clear")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show", "title"]),
    _createVNode(DeactivateEntityModal, {
      show: deactivateModalShow.value,
      onHide: _cache[13] || (_cache[13] = ($event: any) => (deactivateModalShow.value = false)),
      onConfirm: confirmDeactivate
    }, null, 8, ["show"])
  ]))
}
}

})